import script from "./AddTag.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTag.vue?vue&type=script&setup=true&lang=js"

import "./AddTag.vue?vue&type=style&index=0&id=7aaf4992&lang=css"

const __exports__ = script;

export default __exports__